export default "__VITE_ASSET__BTMyLv$w__"